/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsSbomDefinitionBase {
    getFixupPrototypeFunction() { return AppSecopsSbomDefinitionBase.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsSbomDefinitionBase>): AppSecopsSbomDefinitionBase {
        let obj = Object.assign(new AppSecopsSbomDefinitionBase(), model);
        AppSecopsSbomDefinitionBase.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsSbomDefinitionBase>): AppSecopsSbomDefinitionBase {
        if (!model) return null;
        return AppSecopsSbomDefinitionBase.newInstance(<AppSecopsSbomDefinitionBase> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsSbomDefinitionBase) {
        if (!obj) return;

        models.AppSecopsSbomDefinitionBase.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsSbomDefinitionBase): boolean {
        Object.setPrototypeOf(obj, AppSecopsSbomDefinitionBase.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.tags) {
            for (let val of this.tags) {
                models.KeyValuePair.fixupPrototype(val);
            }
        }
    }

    /**
     * Name of the SBOM
     */
    name: string;

    /**
     * SBOM description
     */
    description: string;

    /**
     * Tenant ID
     */
    tenant_id: string;

    /**
     * List of tag key/value pairs
     */
    tags: Array<models.KeyValuePair>;

}
